<template>
  <div>
    <childLogo></childLogo>
    <div class="container">
      <div class="navbar-dark">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">大赛资讯</span>
          </div>
        </div>
        <div style="font-size: 17px;margin-bottom: 15px;color: #5e5e5e;text-align: center">{{ siteName }}</div>
      </div>
      <div style="display: flex;">
        <el-col :span="4">
          <div class="trends-tab" style="background-color: #F3F8FF;margin-right: 10px;">
            <el-tabs v-model="tabValue" :tab-position="tabPosition" class="competition-li" @tab-click="tabClick">
              <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.title"
                :name="item.id + ''"></el-tab-pane>
            </el-tabs>
          </div>

        </el-col>
        <el-row style="min-height: 650px;background-color: #f3f8ff;width: 100%;padding: 0 20px">
          <el-col :span="24">
            <div class="trends-notice" v-if="tabValue === '/ssxw'">
              <div :id="item.id" :class="index === 0 ? 'trends-notice-content' : 'trends-notice-content-two'"
                v-for="(item, index) in notices" :key="index" @click="toDetail(item.id)">
                <el-row>
                  <el-col :xs="16" :sm="20" :md="21" :lg="21" :xl="21">
                    <div class>{{ item.title }}</div>
                  </el-col>
                  <el-col :xs="8" :sm="4" :md="3" :lg="3" :xl="3">
                    <div class style=" color: #a2a2a2">{{ item.releaseDate }}</div>
                  </el-col>
                </el-row>
                <hr style="background-color: #fff; color: #666666" />
              </div>
            </div>
            <div class="video-view">
              <div class="part3-item" v-for="(item, index) in list" :key="index" @click="toDetail(item.id)">
              <video class="image" v-if="item.path" controls nodownload>
                <source :src="item.path" type="video/mp4" />
              </video>
              <img v-else :src="item.coverUrl" class="image">
              <div class="title_bg">
                <p class="title">{{ item.title }}</p>
              </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import ChildLogo from '@/components/ChildLogo.vue'
import { siteMess } from '@/api/system/index'
export default {
  name: 'Trends',
  components: {
    ChildLogo: ChildLogo
  },
  data () {
    return {
      siteName: '',
      channelId: 0,
      notices: [],
      tabList: [
        { id: '/ssyx', title: '赛事影像' },
        { id: '/ssxw', title: '赛事新闻' }
      ],
      tabValue: '/ssyx',
      tabPosition: 'left',
      list: []
    }
  },
  created () {
    siteMess(this.siteURL, this.siteId).then(res => {
      this.siteName = res.data.name
    })
  },
  mounted () {
    this.getNoticeContent('/ssyx')
  },
  methods: {
    getNoticeContent (path) {
      if (path === '/ssyx') {
        // 赛事影像
        var api = this.siteURL + '/actuator/article/selectArticleFile?siteId=' + this.siteId + '&nameEn=ssyx&pageNum=1&pageSize=11000000'
        this.axios.get(api, {}).then((response) => {
          this.list = response.data.rows
        })
      } else {
        var url =
        this.siteURL +
        '/actuator/channel/list?siteId=' +
        this.siteId +
        '&url=' +
        path
        this.axios.get(url, {}).then(response => {
          this.channelId = response.data.rows[0].id
          var api =
          this.siteURL + '/actuator/article/indexList?channelId=' + this.channelId
          this.axios.get(api, {}).then(response => {
            this.notices = response.data.rows
          })
        })
      }
    },
    toDetail (e) {
      let routeUrl = this.$router.resolve({
        path: '/detail',
        query: { id: e }
      })
      window.open(routeUrl.href, '_blank')
    },
    tabClick (e) {
      this.getNoticeContent(e.name)
    }
  }
}
</script>

<style scoped lang="scss">
/* 通知公告基础模块 */
.trends {
  min-height: 80px;
}

/* 通知公告竖线样式 */
.trends-line {
  float: left;
  width: 5px;
  height: 50px;
  background-image: linear-gradient(#133c73, #37babd);
  margin-top: 20px;
}

.trends-text {
  margin-left: 10px;
  float: left;
  height: 40px;
  margin-top: 20px;
}

.trends-text-cn {
  font-size: 24px;
}

.trends-text-en {
  font-size: 15px;
  color: #666666;
}

/* 通知公告内容基础样式 */
.trends-notice {
  margin-top: 10px;
  padding-left: 20px;
  height: 300px;
  color: #666666;
  font-size: 18px;
  text-align: left;
}

/* 通知公告内容基础样式 */
.trends-notice-content {
  padding-top: 40px;
  color: #666666;
  cursor: pointer;
}

.trends-notice-content-two {
  padding-top: 30px;
  color: #666666;
  cursor: pointer;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}

.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0c70fc;
  /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px;
  /*调节线高*/
  left: 0;
}

.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}

.video-view {
  display: flex;flex-wrap: wrap; gap: 30px;
.part3-item {
  width: 284px;
  height: 215px;
  opacity: 1;
  position: relative;
  background: linear-gradient(270deg,
      rgba(239, 246, 255, 0.55) 0%,
      #ecf4fe 100%);
  box-shadow: 0px 2px 4px 0px #d5e5f7;
  border-radius: 2px;

    &:hover {
      cursor: pointer;
    }

    .image {
      width: 100%;
      height: 180px;
      opacity: 1;
      background: rgba(255, 255, 255, 1);
      object-fit: fill;
      position: relative;
    }

    .title_bg {
      z-index: 2;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      color: #343f51;
      text-align: left;
      font-style: normal;
      padding: 4px;
      margin: 0;
      display: flex;
      align-items: center;
      height: 40px;

      .title {
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
}
}
</style>
<style>
/* 去掉右边实线 */
.trends-tab .competition-li .el-tabs__header .el-tabs__nav-wrap::after {
  height: 0% !important;
}

/* 鼠标移入时的颜色改变 */
.trends-tab .el-tabs__item:hover {
  color: #0c70fc !important;
}

/* 选中效果文字与背景颜色修改 */
.trends-tab .el-tabs__item.is-active {
  color: #fff !important;
  background-color: #0c70fc;
}

/* 使元素充满整个div */
.trends-tab .el-tabs__header {
  width: 100% !important;
  height: 100% !important;
}

/* 选项元素样式修改 */
.trends-tab .el-tabs__item {
  color: #707070;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  font-weight: 500;
}

/* 选中后 最右边竖线样式修改 */
.trends-tab .el-tabs__active-bar {
  /* background-image: linear-gradient(#133c73, #37babd); */
  background-color: #0c70fc !important;
}

.trends-tab .el-tabs--left .el-tabs__active-bar.is-left {
  width: 4px;
}

/* 文字居中 */
.trends-tab .el-tabs--left .el-tabs__item.is-left {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/views/Information.vue